import React, { Component } from 'react'
import styled from 'styled-components'
import bg1 from '../assets/img/dialog-5.png'
import bg2 from '../assets/img/dialog-4.png'
import PZBL1 from '../assets/img/PZBL1.png'
import PZBL2 from '../assets/img/PZBL2.png'
import PZBL3 from '../assets/img/PZBL3.png'
import PZBL4 from '../assets/img/PZBL4.png'
import bgShare from '../assets/img/dialog-3.png'
import shareIcon from '../assets/img/shareIcon.png'
import closeBg from '../assets/img/close.png'
import uglyWoman from '../assets/img/uglywoman.png'
import hookImg from '../assets/img/hook.png'
import { vw } from '../untils/styled'
import { submitRes, getFullReport } from '../service'
import { ClientClickTextView } from '../untils/sa-event'
import { validatePhone, getQueryString } from '../untils'
import ReactEcharts from 'echarts-for-react'
import { T } from 'react-toast-mobile'
import html2canvas from 'html2canvas'
import qr from 'qr-image'
import svgpath from 'svgpath'
import riskMap from '../assets/js/risklevel'

const Cover = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 98;
    width: 100%;
    height: 100%;
    background-color: #000000;
    opacity: 0.7;
`

const DialogWrapper = styled.div`
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: ${vw(630)};
    border-radius: 6px;
    background-color: #fff;
    background-image: url(${bg1});
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: 100% auto;
    z-index: 99;
    padding-bottom: ${props => vw(props.pb) || 0};
`

const DialogWrapperShareHide = styled.div`
    position: absolute;
    top: -9999px;
    left: -9999px;
    width: ${vw(690)};
    background-image: none;

    /* .domimgWrapper {
        width: ${vw(650)};
        height: ${vw(879)};
        background: url(${bgShare}) no-repeat;
        background-size: 100% auto;
    } */
`

const DialogWrapperShare = styled(DialogWrapper)`
    top: ${vw(33)};
    transform: translate(-50%, 0);
    width: ${vw(690)};
    background: none;
    border-radius: 0;
`

const DialogWrapperPZBL = styled(DialogWrapper)`
    background-image: url(${bg2});
`

const Close = styled.img`
    position: absolute;
    bottom: ${props => vw(props.bottom || -110)};
    left: 50%;
    transform: translateX(-50%);
    width: ${vw(70)};
    height: ${vw(70)};
`

const Title1 = styled.div`
    width: 100%;
    text-align: center;
    color: #666;
    font-size: ${vw(30)};
    padding-top: ${vw(100)};

    span {
        display: inline-block;
        vertical-align: middle;
    }

    > span:first-of-type {
        width: ${vw(60)};
        height: 1px;
        background-color: #666666;
        opacity: 0.6;
    }

    > span:nth-of-type(2) {
        margin: 0 ${vw(15)};
    }

    > span:last-of-type {
        width: ${vw(60)};
        height: 1px;
        background-color: #666666;
        opacity: 0.6;
    }
`

const Title2 = styled.div`
    width: 100%;
    text-align: center;
    color: #0c0d11;
    font-size: ${vw(40)};
    padding-top: ${vw(100)};
    margin-bottom: ${props => vw(props.mb) || 0};

    span {
        display: inline-block;
        vertical-align: middle;
    }

    > span:first-of-type {
        width: ${vw(17)};
        height: ${vw(17)};
        background-color: #bf904d;
        opacity: 0.7;
        position: relative;
        border-radius: 50%;

        &:before {
            content: '';
            width: ${vw(12)};
            height: ${vw(12)};
            background-color: #bf904d;
            opacity: 0.4;
            position: absolute;
            border-radius: 50%;
            top: ${vw(3)};
            left: ${vw(-25)};
        }

        &:after {
            content: '';
            width: ${vw(7)};
            height: ${vw(7)};
            background-color: #bf904d;
            opacity: 0.2;
            position: absolute;
            border-radius: 50%;
            top: ${vw(5)};
            left: ${vw(-50)};
        }
    }

    > span:nth-of-type(2) {
        margin: 0 ${vw(15)};
    }

    > span:last-of-type {
        width: ${vw(17)};
        height: ${vw(17)};
        background-color: #bf904d;
        opacity: 0.7;
        position: relative;
        border-radius: 50%;

        &:before {
            content: '';
            width: ${vw(12)};
            height: ${vw(12)};
            background-color: #bf904d;
            opacity: 0.4;
            position: absolute;
            border-radius: 50%;
            top: ${vw(3)};
            right: ${vw(-25)};
        }

        &:after {
            content: '';
            width: ${vw(7)};
            height: ${vw(7)};
            background-color: #bf904d;
            opacity: 0.2;
            position: absolute;
            border-radius: 50%;
            top: ${vw(5)};
            right: ${vw(-50)};
        }
    }
`

const Title3 = styled.div`
    width: 100%;
    text-align: center;
    color: #333949;
    font-size: ${vw(40)};
    padding-top: ${vw(90)};
    margin-bottom: ${props => vw(props.mb) || 0};
`

const Introduce = styled.div`
    color: #bf914e;
    font-size: ${vw(36)};
    padding: 0 ${vw(30)};

    > div {
        padding-left: ${vw(60)};
        background: url(${hookImg}) no-repeat;
        background-size: ${vw(40)} ${vw(40)};
        background-position: left center;
        margin-bottom: ${vw(25)};
    }

    > div:last-of-type {
        margin-bottom: ${vw(45)};
    }
`

const SubmitResTitle = styled.div`
    font-family: BigruixianBlackGB;
    font-size: ${vw(62)};
    color: #bf904d;
    text-align: center;
    margin: ${vw(15)} 0 ${vw(50)};
`

const SubmitResInput = styled.input`
    display: block;
    width: ${vw(570)};
    height: ${vw(90)};
    line-height: ${vw(90)};
    margin: 0 auto;
    padding: ${vw(25)} ${vw(30)};
    box-sizing: border-box;
    border-radius: ${vw(8)};
    border: solid 1px #dddddd;
    font-size: ${vw(36)};
    color: #999;
`

const Tips = styled.div`
    color: #999;
    font-size: ${vw(24)};
    margin-top: ${props => vw(props.mt) || 0};
    margin-bottom: ${props => vw(props.mb) || 0};
    padding-left: ${vw(30)};
`

const DialogButton = styled.div`
    width: ${vw(570)};
    height: ${vw(90)};
    line-height: ${vw(90)};
    text-align: center;
    font-size: ${vw(36)};
    color: #fff;
    margin: 0 auto;
	background-image: linear-gradient(90deg, 
		#fcd78d 0%, 
		#bd8e4c 100%);
`

const ShareTips = styled.div`
    color: #999999;;
    font-size: ${vw(30)};
    position: absolute;
    bottom: ${vw(-60)};
    left: 50%;
    width: ${vw(600)};
    text-align: center;
    transform: translateX(-50%);
`

const ZBSMText = styled.div`
    padding: 0 ${vw(30)};
    padding-bottom: ${props => vw(props.pb) || 0};

    > div:first-of-type {
        font-size: ${vw(30)};
        color: #bf904d;
        line-height: ${vw(90)};
    }

    > div:last-of-type {
        font-size: ${vw(24)};
        color: #999;
        line-height: ${vw(36)};
    }
`

const LuckyContent = styled.div`
    padding-top: ${vw(130)};
    padding-bottom: ${vw(90)};
    background-image: ${props => props.isbg ? `url(${uglyWoman})` : 'none'};
    background-repeat: no-repeat;
    background-size: ${vw(210)} ${vw(65)};
    background-position: top left;

    .text1 {
        font-size: ${vw(48)};
        color: #0c0d11;
        text-align: center;
    }

    .text3 {
        position: relative;
        top: -5.5vw;
        font-size: ${vw(48)};
        color: #0c0d11;
        text-align: center;
        font-weight: 600;
    }

    .text2 {
        font-size: ${vw(24)};
        color: #999;
        text-align: center;
        margin: ${vw(28)} auto ${vw(85)};
    }
`

const DomImgShow = styled.img`
    width: ${vw(690)};
`

const PZBLContent = styled.div`
    padding: ${vw(30)} ${vw(53)} ${vw(40)};
`

const PZBLItem = styled.div`
    border-bottom: ${props => props.noBorder ? '0px' : '1px'} solid rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    
    span:first-of-type {
        color: #333949;
        padding: ${vw(25)} 0;
        font-size: ${vw(28)};
        line-height: ${vw(48)};
    }

    span:last-of-type {
        display: flex;
        align-items: center;
        color: #bf904d;
        font-size: ${vw(30)};
        padding-right: ${vw(80)};
        background-image: url(${props => props.bg});
        background-repeat: no-repeat;
        background-size: ${vw(62)} ${vw(62)};
        background-position: right center;
    }
`

const ShareTop = styled.div`
    position: relative;
    background: #404452;
    padding-bottom: ${vw(60)};
`

const ShareBottom = styled.div`
    position: relative;
    background: #fbd17d;
    padding-top: ${vw(200)};
`

const ShareMiddle = styled.div`
    width: ${vw(650)};
    height: ${vw(290)};
    position: absolute;
    top: ${vw(-105)};
    left: ${vw(20)};
    background-color: #fff;
	box-shadow: 0 0 ${vw(38)} 0 rgba(64, 68, 82, 0.5);
    padding: ${vw(24)} ${vw(35)} ${vw(35)};
    box-sizing: border-box;

    .title {
        font-size: ${vw(24)};
        color: #999;
        text-align: center;
        margin-bottom: ${vw(20)};
    }

    .top {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #ddd;
        font-family: BigruixianBlackGB;
        padding-bottom: ${vw(15)};

        .number {
            color: #d8ae68;

            span:first-of-type {
                font-size: ${props => vw(props.middleSize)};
            }
            span:last-of-type {
                font-size: ${vw(30)};
            }
        }

        .type {
            padding-top: ${vw(20)};
            font-size: ${vw(38)};
            color: rgba(0, 0, 0, 0.8);
        }
    }

    .bottom {
        display: flex;
        justify-content: space-between;
        padding-top: ${vw(25)};

        > div {
            span {
                display: block;
                text-align: center;
            }
            span:first-of-type {
                margin-bottom: ${vw(12)};
                font-size: ${vw(36)};
                color: #666;
            }

            span:last-of-type {
                font-size: ${vw(24)};
                color: #999;
            }
        }
    }
`

const ShareBottomContent = styled.div`
    padding: 0 ${vw(30)} ${vw(30)};

    .top {
        color: #795e20;
        font-size: ${vw(20)};
        opacity: 0.7;
        margin-bottom: ${vw(30)};
    }

    .bottom {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        img {
            width: ${vw(200)};
            height: ${vw(45)};
        }

        .tip {
            height: 85px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            color: #010100;
            text-align: right;

            .dog {
                font-size: ${vw(19)};
                color: #795e20;
                opacity: 0.7;
            }

            .cat {
                color: #fff;
                font-size: ${vw(21)};
            }
        }
    }
`


const ShareImg = styled.div`
    display: block;
    width: 85px;
    height: 85px;
    background: #fff;
    padding: ${vw(5)};
    box-sizing: border-box;

    svg {
        transform-origin: top left;
        transform: scale(0.57);
    }
`

export class DialogSubmitRes extends Component {
    constructor() {
        super()
        this.state = {
            phone: '',
            tipsPhone: false
        }
    }
    changeInput = e => {
        let val = e.target.value.replace(/\D/, '')
        if (val.length === 11) {
            let pwdVal = val.replace(/(\d{3})\d{4}(\d{4})/g, '$1****$2')
            ClientClickTextView('资产配置结果前三名将获得', '手机号', '', pwdVal, 11, false)
        }
        this.setState({
            phone: val
        })
    }
    submit = () => {
        if (!validatePhone(this.state.phone)) {
            if (this.state.phone.length === 11) {
                ClientClickTextView('资产配置结果前三名将获得', '手机号', '', this.state.phone, this.state.phone.length, false)
            }
            this.setState({
                tipsPhone: true
            })
            return
        }
        ClientClickTextView('资产配置结果前三名将获得', '手机号', '', this.state.phone.replace(/(\d{3})\d{4}(\d{4})/g, '$1****$2'), 11, true)
        submitRes({
            serialNo: this.props.serialNo,
            mobileNo: this.state.phone,
            flag: getQueryString('id') === '000' ? '1' : '2'
        }).then(res => {
            if (res.rstcode === '000000') {
                this.props.dialogCentre(true, 'lucky');
            } else if (res.rstcode === '999999') {
                this.props.dialogCentre(true, 'fail');
            }
        })
    }
    render() {
        return (
            <div>
                <DialogWrapper>
                    <Title1>
                        <span></span>
                        <span>资产配置结果前三名将获得</span>
                        <span></span>
                    </Title1>
                    <SubmitResTitle>666元现金红包！</SubmitResTitle>
                    <SubmitResInput
                        type="text"
                        value={this.state.phone}
                        placeholder='手机号'
                        maxLength='11'
                        onChange={this.changeInput} />
                    <Tips mt={20} mb={55}>{this.state.tipsPhone && '*请输入正确的手机号码'}</Tips>
                    <DialogButton onClick={this.submit}>提交</DialogButton>
                    <Tips mt={25}>*现场用户每人仅可提交1次，分享参与视为无效；</Tips>
                    <Tips>*结果相同时提交时间早的用户排名在先；</Tips>
                    <Tips>*现场用户将凭入场证及主持人拨打号码领取奖品；</Tips>
                    <Tips mb={75}>*领奖通知过时不候，不在现场视为自动弃权；</Tips>
                    <Close onClick={this.props.dialogCentre.bind(this, false)} src={closeBg}></Close>
                </DialogWrapper>
                <Cover></Cover>
            </div>
        )
    }
}

export class DialogShare extends Component {
    constructor(props) {
        super(props)
        this.domToImgRef = React.createRef();
        this.imgFlag = 0
        this.state = {
            domimgSrc: '',
            path: ''
        }
        this.chartEvent = {
            'finished': this.imgsLoad
        }
        // T.loading('图片加载中~');
    }
    componentDidMount() {
        let targetUrl = 'https://im.zlfund.cn/m_xzg_xxltg/hormats/'
        let userId
        let media = getQueryString('utm_term')

        if (localStorage.getItem('userId')) {
            userId = localStorage.getItem('userId')
        } else {
            userId = Math.ceil(Math.random() * 1000)
            localStorage.setItem('userId', userId)
        }
        if (media) {
            targetUrl = `${targetUrl}?id=${media}-${userId}`
        } else {
            targetUrl = `${targetUrl}?id=${userId}`
        }
        const originPath = qr.svgObject(targetUrl).path
        const scaledPath = svgpath(originPath).scale(4, 4).toString()
        this.setState({ path: scaledPath })
    }
    chartBarOption = () => {
        const calcAror = () => {
            return [this.props.calc.aror, this.props.calc.arorZl, this.props.calc.arorHs300]
        }
        const calcSharperatio = () => {
            return [this.props.calc.sharperatio, this.props.calc.sharperatioZl, this.props.calc.sharperatioHs300]
        }
        const calcMaxdrawdown = () => {
            return [this.props.calc.maxdrawdown, this.props.calc.maxdrawdownZl, this.props.calc.maxdrawdownHs300]
        }

        return {
            legend: {
                data: [
                    {
                        name: '夏普比率',
                        icon: 'rect'
                    },
                    {
                        name: '年化收益率',
                        icon: 'rect'
                    },
                    {
                        name: '最大回撤',
                        icon: 'rect'
                    }
                ],
                itemGap: 25,
                itemWidth: 10,
                itemHeight: 10,
                textStyle: {
                    color: 'rgba(255, 255, 255, 0.7)'
                },
                left: 50,
                bottom: 30
            },
            grid: {
                top: 40,
                left: 5,
                right: 20,
                containLabel: true
            },
            xAxis: {
                type: 'category',
                // offset: 50,
                data: ['您的配置', '众禄配置', '沪深300'],
                splitLine: { show: false },//去除网格线
                axisLabel: {
                    color: 'rgba(255, 255, 255, 1)',
                    fontFamily: 'Microsoft YaHei',
                    fontSize: 14
                },
                axisLine: {
                    color: '#31343e'
                }
            },
            yAxis: [{
                splitLine: {
                    lineStyle: {
                        color: '#31343e'
                    }
                },
                type: 'value',
                axisLabel: {
                    interval: 10,
                    color: 'rgba(255, 255, 255, 0.2)'
                },
                axisLine: {
                    show: false
                }
            }],
            series: [{
                name: '年化收益率',
                type: 'bar',
                itemStyle: {
                    normal: {
                        color: '#fcd78d',
                        label: {
                            show: true,
                            fontSize: 10,
                            position: 'top'
                        }
                    }
                },
                data: calcAror()
            }, {
                name: '夏普比率',
                type: 'bar',
                itemStyle: {
                    normal: {
                        color: '#7f88a3',
                        label: {
                            show: true,
                            fontSize: 10,
                            position: 'top'
                        }
                    }
                },
                data: calcSharperatio()
            }, {
                name: '最大回撤',
                type: 'bar',
                itemStyle: {
                    normal: {
                        color: '#ff7d43',
                        label: {
                            show: true,
                            fontSize: 10,
                            position: 'bottom'
                        }
                    }
                },
                data: calcMaxdrawdown()
            }]
        }
    }
    imgsLoad = () => {
        this.imgFlag++
        if (this.imgFlag === 2) {
            // domtoimage bug in ios fuck
            // domtoimage.toPng(this.domToImgRef.current)
            // .then( dataUrl => {
            //     // T.loaded()
            //     this.setState({
            //         domimgSrc: dataUrl
            //     })
            // })
            // .catch(error => {
            //     // T.loaded()
            //     html2canvas(this.domToImgRef.current).then(function(canvas) {
            //         document.body.appendChild(canvas);
            //     });
            //     console.error('oops, something went wrong!', error);
            // });
            html2canvas(this.domToImgRef.current).then((canvas) => {
                let dataURL = canvas.toDataURL();
                this.setState({
                    domimgSrc: dataURL
                })
            });
        }
    }
    render() {
        const riskTextObj = riskMap[this.props.calc.risklevel - 1];
        const numberFormat = String(this.props.calc.income).replace(/(?!^)(?=(\d{3})+$)/g, ',')
        const numberFontSize = (() => {
            let length = numberFormat.length;
            if (length > 6) {
                return 450 / length;
            } else {
                return 64;
            }
        })();

        return (
            <div>
                {
                    !this.state.domimgSrc &&
                    <DialogWrapperShareHide>
                        <div className='domimgWrapper' ref={this.domToImgRef}>
                            <ShareTop>
                                <ReactEcharts
                                    style={{height: '60vw', width: '100%'}}
                                    option={this.chartBarOption()}
                                    onEvents={this.chartEvent}></ReactEcharts>
                            </ShareTop>

                            <ShareBottom>
                                <ShareMiddle middleSize={numberFontSize}>
                                    <div className='title'>根据资产配置计算器，预测您未来一年的投资收益为</div>
                                    <div className='top'>
                                        <div className='number'>
                                            <span>{numberFormat}</span>
                                            <span>元</span>
                                        </div>
                                        <div className='type'>{riskTextObj.level}</div>
                                    </div>
                                    <div className='bottom'>
                                        <div>
                                            <span>{this.props.calc.sharperatio}</span>
                                            <span>夏普比率</span>
                                        </div>
                                        <div>
                                            <span>{(this.props.calc.aror * 100).toFixed(2) + '%'}</span>
                                            <span>年化收益率</span>
                                        </div>
                                        <div>
                                            <span>{(this.props.calc.maxdrawdown * 100).toFixed(2) + '%'}</span>
                                            <span>最大回撤</span>
                                        </div>
                                    </div>
                                </ShareMiddle>
                                <ShareBottomContent>
                                    <div className='top'>*根据用户投资金额及资产配置比例，以过往12年市场行情历史数据为蓝本，预测收益结果仅供参考，以实际投资为准。</div>
                                    <div className='bottom'>
                                        <img onLoad={this.imgsLoad} src={shareIcon} alt=""/>
                                        <div className='tip'>
                                            <div className='dog'>长按二维码体验<br />资产配置</div>
                                            <div className='cat'>12年专注全球资产配置<br />中国本土化研究及实战</div>
                                        </div>
                                        <ShareImg>
                                            <svg ref={(ref) => this._qrcodeSVG = ref} >
                                                <path d={this.state.path ? this.state.path : null} />
                                            </svg>
                                        </ShareImg>
                                    </div>                                    
                                </ShareBottomContent>
                            </ShareBottom>
                        </div>
                    </DialogWrapperShareHide>
                }
                {
                    !this.state.domimgSrc &&
                    <DialogWrapperShare>
                        <div>
                            <ShareTop>
                                <ReactEcharts style={{height: '65vw', width: '100%'}} option={this.chartBarOption()}></ReactEcharts>
                            </ShareTop>

                            <ShareBottom>
                                <ShareMiddle middleSize={numberFontSize}>
                                    <div className='title'>根据资产配置计算器，预测您未来一年的投资收益为</div>
                                    <div className='top'>
                                        <div className='number'>
                                            <span>{numberFormat}</span>
                                            <span>元</span>
                                        </div>
                                        <div className='type'>{riskTextObj.level}</div>
                                    </div>
                                    <div className='bottom'>
                                        <div>
                                            <span>{this.props.calc.sharperatio}</span>
                                            <span>夏普比率</span>
                                        </div>
                                        <div>
                                            <span>{(this.props.calc.aror * 100).toFixed(2) + '%'}</span>
                                            <span>年化收益率</span>
                                        </div>
                                        <div>
                                            <span>{(this.props.calc.maxdrawdown * 100).toFixed(2) + '%'}</span>
                                            <span>最大回撤</span>
                                        </div>
                                    </div>
                                </ShareMiddle>
                                <ShareBottomContent>
                                    <div className='top'>*根据用户投资金额及资产配置比例，以过往12年市场行情历史数据为蓝本，预测收益结果仅供参考，以实际投资为准。</div>
                                    <div className='bottom'>
                                        <img src={shareIcon} alt=""/>
                                        <div className='tip'>
                                            <div className='dog'>长按二维码体验<br />资产配置</div>
                                            <div className='cat'>12年专注全球资产配置<br />中国本土化研究及实战</div>
                                        </div>
                                        <ShareImg>
                                            <svg ref={(ref) => this._qrcodeSVG = ref} >
                                                <path d={this.state.path ? this.state.path : null} />
                                            </svg>
                                        </ShareImg>
                                    </div>                                    
                                </ShareBottomContent>
                            </ShareBottom>

                            <ShareTips>长按保存图片分享到朋友圈</ShareTips>
                            <Close bottom={-140} onClick={this.props.dialogCentre.bind(this, false)} src={closeBg}></Close>
                        </div>
                    </DialogWrapperShare>
                }


                {
                    this.state.domimgSrc &&
                    <DialogWrapperShare>
                        <ShareTips>长按保存图片分享到朋友圈</ShareTips>
                        <Close bottom={-140} onClick={this.props.dialogCentre.bind(this, false)} src={closeBg}></Close>
                        <DomImgShow src={this.state.domimgSrc}></DomImgShow>
                    </DialogWrapperShare>
                }
                <Cover></Cover>
            </div>
        )
    }
}

export class DialogZBSM extends Component {
    render() {
        return (
            <div>
                <DialogWrapper>
                    <Title2>
                        <span></span>
                        <span>指标说明</span>
                        <span></span>
                    </Title2>
                    <ZBSMText>
                        <div>夏普比率</div>
                        <div>每承受一单位总风险，会产生多少的超额报酬。评价投资结果的“性价比”。</div>
                    </ZBSMText>
                    <ZBSMText>
                        <div>年化收益率</div>
                        <div>多年的收益平均到每年的数值。</div>
                    </ZBSMText>
                    <ZBSMText pb={100}>
                        <div>最大回撤</div>
                        <div>在选定周期内任一历史时点往后推，产品净值走到最低点时的收益率回撤幅度的最大值。最大回撤用来描述买入产品后可能出现的最糟糕的情况。</div>
                    </ZBSMText>
                    <Close onClick={this.props.dialogCentre.bind(this, false)} src={closeBg}></Close>
                </DialogWrapper>
                <Cover></Cover>
            </div>
        )
    }
}

export class DialogLucky extends Component {
    render() {
        return (
            <div>
                <DialogWrapper>
                    <LuckyContent>
                        <div className='text1'>提交成功，祝您好运~</div>
                        <div className='text2'>请留意现场大屏幕公布结果</div>
                        <DialogButton onClick={this.props.dialogCentre.bind(this, false, '我知道了')}>我知道了</DialogButton>
                    </LuckyContent>
                    <Close onClick={this.props.dialogCentre.bind(this, false)} src={closeBg}></Close>
                </DialogWrapper>
                <Cover></Cover>
            </div>
        )
    }
}

export class DialogFail extends Component {
    render() {
        return (
            <div>
                <DialogWrapper>
                    <LuckyContent>
                        <div className='text1'>提交失败~</div>
                        <div className='text2'>您已提交过报告结果，请留意现场大屏幕公布结果</div>
                        <DialogButton onClick={this.props.dialogCentre.bind(this, false, '我知道了')}>我知道了</DialogButton>
                    </LuckyContent>
                    <Close onClick={this.props.dialogCentre.bind(this, false)} src={closeBg}></Close>
                </DialogWrapper>
                <Cover></Cover>
            </div>
        )
    }
}

export class DialogSuccess extends Component {
    uglyWoman = () => {
        this.props.dialogCentre(false, '查看完整报告');
        const devURL = 'http://172.18.20.209:3001'
        const proURL = 'https://m.jjmmw.com/zt/hormats-report/'
        window.location = `${process.env.NODE_ENV==='production' ? proURL : devURL}?serialNo=${this.props.serialno}`
    }
    render() {
        console.log(this.props.serialno);
        return (
            <div>
                <DialogWrapper>
                    <LuckyContent isbg>
                        <div className='text1'>提交成功！</div>
                        <div className='text2'>众禄基金资产配置专家服务咨询专线：</div>
                        <div className='text3'>4006-788-887</div>
                        <DialogButton onClick={this.uglyWoman}>查看完整报告</DialogButton>
                    </LuckyContent>
                    <Close onClick={this.props.dialogCentre.bind(this, false)} src={closeBg}></Close>
                </DialogWrapper>
                <Cover></Cover>
            </div>
        )
    }
}

export class DialogGetReport extends Component {
    constructor() {
        super()
        this.state = {
            phone: '',
            name: '',
            tipsPhone: false,
            tipsName: false
        }
    }
    submit = () => {
        if (!this.state.name) {
            this.setState({
                tipsName: true
            })
            return
        } else {
            this.setState({
                tipsName: false
            })
        }
        if (!validatePhone(this.state.phone)) {
            if (this.state.phone.length === 11) ClientClickTextView('根据计算结果获得投资策略', '手机号', this.state.name, this.state.phone, this.state.phone.length, false)
            this.setState({
                tipsPhone: true
            })
            return
        } else {
            this.setState({
                tipsPhone: false
            })
        }
        let request = () => {
            getFullReport({
                serialNo: this.props.serialno,
                mobileno: this.state.phone,
                invnm: this.state.name
            }).then(res => {
                if (res.rstcode === '000000') {
                    this.props.next()
                }
            })            
        }

        if (this.props.serialno) {
            request()
        } else {
            // 如果用户在计算未完成之前就输入完成并提交姓名手机号
            // 虽然正常人没这手速，但还是预防一下
            T.loading('资产配置穿越牛熊市，追求中长期稳健收益')
            let interval = setInterval(() => {
                if (this.props.serialno) {
                    clearInterval(interval)
                    T.loaded()
                    request()
                }
            }, 500)
        }

        ClientClickTextView('根据计算结果获得投资策略', '手机号', this.state.name, this.state.phone.replace(/(\d{3})\d{4}(\d{4})/g, '$1****$2'), 11, true)
    }
    changeName = e => {
        this.setState({
            name: e.target.value
        })
    }
    changePhone = e => {
        let val = e.target.value.replace(/\D/, '')
        if (e.target.value.length === 11) {
            ClientClickTextView('根据计算结果获得投资策略', '手机号', this.state.name, e.target.value.replace(/(\d{3})\d{4}(\d{4})/g, '$1****$2'), 11, false)
        }
        this.setState({
            phone: val
        })
    }
    render() {
        return (
            <div>
                <DialogWrapper pb={78}>
                    <Title3 mb={54}>
                        <span>根据计算结果获得投资策略</span>
                    </Title3>
                    <Introduce>
                        <div>1次持仓针对分析</div>
                        <div>十二年老牌投资机构研究报告</div>
                    </Introduce>
                    <SubmitResInput
                        type="text"
                        value={this.state.name}
                        placeholder='姓名'
                        maxLength='50'
                        onChange={this.changeName} />
                    <Tips mt={20} mb={20}>{this.state.tipsName && '*请输入姓名'}</Tips>
                    <SubmitResInput
                        type="text"
                        value={this.state.phone}
                        placeholder='手机号'
                        maxLength='11'
                        onChange={this.changePhone} />
                    <Tips mt={20} mb={40}>{this.state.tipsPhone && '*请输入正确的手机号码'}</Tips>
                    <DialogButton onClick={this.submit}>提交</DialogButton>
                    <Close onClick={this.props.changeState.bind(this, false)} src={closeBg}></Close>
                </DialogWrapper>
                <Cover></Cover>
            </div>
        )
    }
}

export class DialogPZBL extends Component {
    render() {
        return (
            <div>
                <DialogWrapperPZBL>
                    <PZBLContent>
                        <PZBLItem bg={PZBL1}>
                            <span>上证企业债</span>
                            <span>固定收益类</span>
                        </PZBLItem>
                        <PZBLItem bg={PZBL3}>
                            <span>大宗商品（工业品）</span>
                            <span>原油</span>
                        </PZBLItem>
                        <PZBLItem bg={PZBL4}>
                            <span>大宗商品（避险工具）</span>
                            <span>黄金</span>
                        </PZBLItem>
                        <PZBLItem noBorder bg={PZBL2}>
                            <span>
                                沪深300指数（大盘）<br />
                                中证500指数（小盘）<br />
                                标普500指数（美股）
                            </span>
                            <span>权益类</span>
                        </PZBLItem>
                    </PZBLContent>
                    <Close onClick={this.props.dialogCentre.bind(this, false)} src={closeBg}></Close>
                </DialogWrapperPZBL>
                <Cover></Cover>
            </div>
        )
    }
}
